// src/components/ui/Loading.js
import React from 'react';
import { Loader } from 'lucide-react';

const Loading = ({ msg = 'Chargement...' }) => (
  <div className="flex flex-col items-center py-16">
    <Loader className="w-10 h-10 text-rose-500 animate-spin mb-3" />
    <p className="text-gray-500 dark:text-gray-400">{msg}</p>
  </div>
);

export default Loading;
